module.exports = {
    menu: {
        index: "INDEX",
        signUp: "SIGN UP",
        live: "LIVE",
        agenda: "AGENDA",
        personal: "PERSONAL CENTER",
    },
    index: {
        poster: "https://oss.eventnet.cn/H5/mi/pc_video_en.png",
        src: "https://oss.eventnet.cn/H5/mi/pc_video_en.mp4?v=1140"
    },
    index_mobile: {
        poster: "https://oss.eventnet.cn/H5/mi/mobile_video_en.png",
        src: "https://oss.eventnet.cn/H5/mi/mobile_video_en.mp4?v=1140",
        gif: "https://oss.eventnet.cn/H5/mi/mobile_video_en.gif"
    },
    share: {
        title: "XIAOMI CORPORATION 2021 INVESTOR DAY",
        time_place: "October 19, 2021Xiaomi Science and Technology Park",
        img: ""
    },
    signUp: {
        name: {
            title: "NAME",
            placeholder: "Name",
        },
        job_title: {
            title: "TITLE",
            placeholder: "Title",
        },
        company: {
            title: "INSTITUTION",
            placeholder: "Institution",
        },
        email: {
            title: "EMAIL",
            title1: "Login email",
            placeholder: "Email",
            error: "Incorrect email",
        },
        password: {
            title: "PASSWORD",
            title1: "REGISTRATION", //INFORMATION
            title2: "PASSWORD",
            placeholder: "Enter password",
            error: "At least 8 characters for password",
            error1: "Incorrect password format",
            tips1: "8-14 characters",
            tips2: "At least two of three formats: letter, digit and punctuation",
            tips3: "No spaces, Chinese characters and special symbols"
        },
        password1: {
            title: "CONFIRM PASSWORD",
            placeholder: "Please confirm password",
            error: "Passwords entered are inconsistent",
        },
        cellphone: {
            title: "TELEPHONE",
            placeholder: "Phone number",
            error: "Enter a correct phone number"
        },
        country: {
            title: "COUNTRY",
            placeholder: "Country",
        },
        region: {
            title: "REGION",
            placeholder: "Region",
        },
        meeting_type: {
            title: "MEETING TYPE",
            placeholder: "Meeting type",
            select: {
                checkA: { value: "Online meeting", option: 2 },
                checkB: { value: "Offline meeting", option: 1 },
            }
        },
        is_dine: {
            title: "LUNCH",
            placeholder: "Lunch or not",
            select: {
                checkA: { value: "Lunch on the 19th", option: 1 },
                checkB: { value: "No", option: 2 },
            }
        },
        tips: "THE REGISTRATION DEADLINE IS OCTOBER 8",
        btn: "SUBMIT",
        success: "SUBMITTED SUCCESSFULLY",
        success_tip1: "DEAR INVESTORS,",
        success_tip2: "THE CONFERENCE ORGANIZING COMMITTEE HAS RECEIVED YOUR REGISTRATION INFORMATION, AND WE WILL SEND THE CONFIRMATION LETTER TO YOUR EMAIL ONCE CONFIRMED.",
        success_tip3: "YOU MAY CHECK YOUR REGISTRATION STATUS AT THE PERSONAL CENTER ON OCTOBER 12.",
        success_tip4: "THE CONFERENCE WILL BE LIVE STREAMED ON OCTOBER 19.",
        login_tips: "Please log in first",
        tips_password: "Password is used for login",
        error:"We are sorry to inform you that capacity is full for the offline Investor Day. Please kindly join our events online."
    },
    login: {
        title: "Login",
        toRegister: "Registration",
        toLogin: "Registered, Login",
        success: "Login succeeded",
        password: "Forget password？",
        signOut: "Exit",
        please_register: "Incorrect password or user name",
    },
    register: {
        title: "Register",
        success: "Successfully registered",
        repeat: "Do not register repeatedly",
        last: "Back",
        confirm: "Done",
        error: "Enter more information"
    },
    personal: {
        tips1: "REGISTRATION APPROVED",
        tips2: "REGISTRATION FAILED",
        tips3: "INFORMATION UNDER REVIEW..."
    },
    waiting: {
        title: "Registration deadline, thank you for your attention"
    },
    password: {
        title: "Retrieve your password via your email",
        title1: "GET A SIX-DIGIT VERIFICATION CODE VIA YOUR EMAIL",
        next: "Next",
        btn: "Click Get",
        success: "Password changed",
        confirm: "CONFIRM TO RESET THE PASSWORD",
        code: {
            title: "Code",
            placeholder: "Code",
            success: "Verification code has been sent",
            error: "Incorrect verification code"
        },
        password: {
            title: "New password",
            placeholder: "Enter the new password",
            error: "At least 6 characters for password",
        },
        password1: {
            title: "Confirm password",
            placeholder: "Please confirm password",
            error: "Passwords entered are inconsistent",
        },
    },
    live: {
        liveNumber: 'Number of viewers',
        send: 'Send',
        saySome: 'Say something',
        YourComment: 'Your comment',
        Block: 'Block',
        BlockTill: 'Block till',
        Interaction: 'Interaction',
        CommentsUnderReview: 'Comments under review...',
        downmsg: 'Drop down to load more history messages',
        newmsg:' new messages',
        live:'LIVE',
        livelink:'https://yunqicdn.aodianyun.com/play-163.html'
    },
    pcagenda:{
        src:'https://oss.eventnet.cn/H5/mi/agenda_en.jpeg?v=1.11'
    },
    magenda:{
        src:'https://oss.eventnet.cn/H5/mi/agenda_m_en.jpeg?v=1.11'
    }
};


// WEBPACK FOOTER //
// ./src/i18n/en.js